import { useEffect, useRef } from "react";
import SocketClient from "../../../socket/SocketClient";
import { TURNO_EVENTO } from "../constants";

const EVENTO_CONECTADO = "connect";

/**
 * Hook que suscribe la pantalla a los eventos de turno de una cola. Abre un
 * SocketClient por idCola, entra en la sala `cola:<id>` en cada conexión y lo
 * cierra al desmontar quitando todos sus listeners. Los callbacks se leen desde
 * un ref: cambiarlos no reconecta el socket.
 * @param {Object} params
 * @param {string|null} params.idCola - Id de la cola (sin id no se abre socket)
 * @param {(turno: Object) => void} [params.onLlamado] - turno:llamado
 * @param {(turno: Object) => void} [params.onEsperando] - turno:esperando
 * @param {() => void} [params.onCambio] - turno:finalizar, turno:saltar y turno:eliminar
 * @param {() => void} [params.onConectado] - Tras unirse a la sala (conexión y reconexiones)
 */
export const useTurnosSocket = ({ idCola, onLlamado, onEsperando, onCambio, onConectado }) => {
    const callbacks = useRef({});
    callbacks.current = { onLlamado, onEsperando, onCambio, onConectado };

    useEffect(() => {
        if (!idCola) return undefined;

        const socket = new SocketClient();
        // Un handler que lanza no debe romper la suscripción de los demás
        const despachar = (nombre) => (...args) => {
            try {
                callbacks.current[nombre]?.(...args);
            } catch (err) {
                console.error(`Error en ${nombre}:`, err);
            }
        };
        // DECISION: el servidor olvida las rooms al reconectar, así que se une a
        // la sala en CADA 'connect' (el legacy solo lo hacía una vez y la TV dejaba
        // de actualizarse en silencio tras un corte de red)
        const alConectar = () => {
            socket.joinCola(idCola);
            despachar("onConectado")();
        };
        const handlers = [
            [TURNO_EVENTO.LLAMADO, despachar("onLlamado")],
            [TURNO_EVENTO.ESPERANDO, despachar("onEsperando")],
            [TURNO_EVENTO.FINALIZAR, despachar("onCambio")],
            [TURNO_EVENTO.SALTAR, despachar("onCambio")],
            [TURNO_EVENTO.ELIMINAR, despachar("onCambio")],
            [EVENTO_CONECTADO, alConectar],
        ];

        handlers.forEach(([evento, handler]) => socket.on(evento, handler));
        socket.connect();

        return () => {
            handlers.forEach(([evento, handler]) => socket.off(evento, handler));
            socket.disconnect();
        };
    }, [idCola]);
};
